import YCLatLng from "./YCLatLng";

class MapMarker {
  constructor(customLat, customLng, realLat, realLng) {
    this.realPoint = new YCLatLng(realLat, realLng);
    this.customPoint = new YCLatLng(customLat, customLng);
  }
}

export default MapMarker;
